import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../../i18n';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {mapDispatchToProps} from "../../mapDispatchToProps"
import withBaseComponent from '../../withBaseComponent';

class ConfirmSuspend extends withBaseComponent(React.Component) {
  onSubmit() {
    const {id} = this.props.account

    this.props.accountActions.accountSuspend(id).then(() => {
      this.props.accountActions.accountShow(id).then(() => {
        this.props.toggle()
        this.props.onSuspended()
      })
    })
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} className={this.props.className} centered={true}>
        <ModalHeader toggle={this.props.toggle}>{i18n.t('bank.settings.stop_get_data')}</ModalHeader>
        <ModalBody>
          <div>
            <div>データ取得を停止しますと口座の定期的な自動取得を停止します。</div>
            <br />
            <div>また、本口座におけるログイン情報を削除するため、データ取得を再開する際にログイン情報を再度入力しなおす必要があります。</div>
            <br />
            <div>データ取得を停止しますか？</div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.toggle} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
          <button className="btn mfc-btn-red" type="button" onClick={() => this.onSubmit()}>
            {i18n.t('common.stop')}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmSuspend)
